export class CbmPaymentContentUtil {
    public static isOrionTenant: boolean = false;
    public static accountAuthGuid: string = '';

    public static setOrionTenant(isOrionTenant: boolean): void {
        CbmPaymentContentUtil.isOrionTenant = isOrionTenant;
    }

    public static setAccountAuthGuid(authGuid?: string): void {
        CbmPaymentContentUtil.accountAuthGuid = authGuid || '';
    }

    public static getAccountAuthGuid(authGuid?: string): string {
        if (!authGuid) {
            return CbmPaymentContentUtil.accountAuthGuid || '';
        }

        return authGuid;
    }

    public static selectPaymentUrl(cbmSmbUrl?: string, cbmOsUrl?: string): string {
        if (CbmPaymentContentUtil.isOrionTenant) {
            return cbmOsUrl;
        }

        return cbmSmbUrl;
    }

    public static resolvePaymentUrl(
        url: string,
        paymentBaseUrl: string,
        authGuid?: string,
        siteId?: string
    ): string {
        if (!url) {
            return url;
        }

        const authGuidToUse: string = CbmPaymentContentUtil.getAccountAuthGuid(authGuid);

        return url
            .replace('[CBM_PAYMENT_BASE_URL]', paymentBaseUrl)
            .replace('[AUTH_GUID]', authGuidToUse)
            .replace('[SITE_ID]', siteId || '')
            .replace('[PAYMENT_BASE_URL]', paymentBaseUrl);
    }
}